import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'

export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [categories, setCategories] = useState([])

  const getAppTypes = async () => {
    const { response } = await AppService.roadmap.get_roadmap({
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getCategory = async () => {
    const { response } = await AppService.AppsChecklist.get_app_name({
      toaster: false,
    })
    if (response) {
      setCategories(response.data)
    } else {
      setCategories([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
    getCategory()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.roadmap.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    categories: categories,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Status', accessor: 'status' },
        // { Header: 'roadmap_type', accessor: 'roadmap_type' },

        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data.name,
        status: data.status,
        // roadmap_type: data.roadmap_type,


        action: (
          <MDBox>
            <EditModal categories={categories} data={data} handleRefresh={onLoad} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
